import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OperationTypeEnum } from '@gtpl/shared-models/common-models';

export class GradeInventoryRequest {
    @ApiProperty({
        enum: OperationTypeEnum
      })
      // @IsEnum(OperationTypeEnum)
      operation: OperationTypeEnum;
    @ApiProperty()
    @IsNotEmpty()
    plantId: number;
}